import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { undoModuleReducerChange, redoModuleReducerChange
//@ts-expect-error no types
} from 'ContentEditorUI/redux/actions/undoRedoActions';
import { selectCanUndoInstanceEditingState, selectCanRedoInstanceEditingState } from 'structured-content-lib/redux/selectors/instanceEditSelectors';
import { getIsReadOnlyMode } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
// @ts-expect-error not typed
import { setScrollTo } from 'ContentEditorUI/redux/actions/baseSettingsActions';
import { selectKnowledgeBaseThemeVariant } from '../../settings/selectors/knowledgeBaseSelectors';

// @ts-expect-error not typed
import { updatePatagoniaSettingsModalActiveNavItem } from 'ContentEditorUI/redux/actions/baseSettingsActions';
import { MODAL_TYPES } from 'ContentEditorUI/lib/modalConstants';
import { openModal
// @ts-expect-error not typed
} from 'ContentEditorUI/redux/actions/appActions';
import { selectCurrentInstance } from 'structured-content-lib/redux/selectors/instanceEditSelectors';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { getContentAccessControlEditPermissionsDisabledTooltipI18nKey } from 'ui-memberships-settings-lib/utils/tooltips';
import { ContentTypes } from 'ui-memberships-settings-lib/constants/ContentTypes';
import { createArticle } from '../../articles/api/articlesApi';
import { getEditorUrl, getKnowledgeArticleDetailsUrl, getThemeSettingsEditorUrl } from '../../utils/urls';
import { getDefaultArticleName } from '../../articles/constants/ArticleConstants';
import { useAppSelector } from '../../reducers';
import { selectHasArticlePublishPermission, selectHasArticleWritePermission, selectHasServicePrivateContentAccess, selectIsUngatedForLocalizationArticleTitle, selectIsUngatedForRevisionHistory, selectUserHasManagePrivateContentPermission } from '../../auth/selectors/auth';
import { KB_MODAL_TYPES } from '../../types/ModalTypes';
// @ts-expect-error not typed
import { routeToPage } from 'ContentEditorUI/redux/actions/routingActions';
import { jsx as _jsx } from "react/jsx-runtime";
const GENERAL_TAB = 'general';
const CATEGORIES_TAB = 'categories';
const METADATA_TAB = 'metadata';
const ADVANCED_TAB = 'advanced';
const AUDIENCE_ACCESS_TAB = 'audienceAccess';
const useSettingsDropdownOptions = () => {
  const dispatch = useDispatch();
  const hasWritePermission = useSelector(selectHasArticleWritePermission);
  const portalHasPrivateContentAccess = useSelector(selectHasServicePrivateContentAccess);
  const userCanViewContentAccessControl = portalHasPrivateContentAccess && hasWritePermission;
  const userHasManagePrivateContentPermission = useAppSelector(selectUserHasManagePrivateContentPermission);
  const openSettingsModalFromNavItem = useCallback(navItem => {
    dispatch(openModal(KB_MODAL_TYPES.SETTINGS_MODAL));
    dispatch(setScrollTo(navItem));
  }, [dispatch]);
  return useMemo(() => {
    const settingsDropdownOptions = [{
      id: GENERAL_TAB,
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeArticleEditorUI.settingsModal.generalTabLabel"
      }),
      onClick: () => openSettingsModalFromNavItem(GENERAL_TAB)
    }, {
      id: CATEGORIES_TAB,
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeArticleEditorUI.settingsModal.categoriesTabLabel"
      }),
      onClick: () => openSettingsModalFromNavItem(CATEGORIES_TAB)
    }, {
      id: METADATA_TAB,
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeArticleEditorUI.settingsModal.metadataTabLabel"
      }),
      onClick: () => openSettingsModalFromNavItem(METADATA_TAB)
    }, {
      id: ADVANCED_TAB,
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeArticleEditorUI.settingsModal.advancedTabLabel"
      }),
      onClick: () => openSettingsModalFromNavItem(ADVANCED_TAB)
    }];
    if (userCanViewContentAccessControl) {
      settingsDropdownOptions.splice(-1, 0, {
        id: AUDIENCE_ACCESS_TAB,
        text: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeArticleEditorUI.settingsModal.accessControlTabLabel"
        }),
        onClick: () => openSettingsModalFromNavItem(AUDIENCE_ACCESS_TAB),
        disableLink: !userHasManagePrivateContentPermission,
        tooltipLabel: !userHasManagePrivateContentPermission ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: getContentAccessControlEditPermissionsDisabledTooltipI18nKey(ContentTypes.KNOWLEDGE_ARTICLE)
        }) : null
      });
    }
    return settingsDropdownOptions;
  }, [openSettingsModalFromNavItem, userCanViewContentAccessControl, userHasManagePrivateContentPermission]);
};
export const useNavigationGroups = ({
  onDeleteClick
}) => {
  const dispatch = useDispatch();
  const isReadOnlyMode = useSelector(getIsReadOnlyMode);
  const canRedoModules = useSelector(selectCanRedoInstanceEditingState);
  const canUndoModules = useSelector(selectCanUndoInstanceEditingState);
  const hasPublishPermission = useSelector(selectHasArticlePublishPermission);
  const themeVariant = useSelector(selectKnowledgeBaseThemeVariant);
  const [isCreatingArticle, setIsCreatingArticle] = useState(false);
  const currentInstance = useAppSelector(selectCurrentInstance);
  // const articleIsPublished =
  //   currentInstance && currentInstance.values
  //     ? !!currentInstance.values.hs_published_at
  //     : null;
  const currentArticleId = currentInstance && currentInstance.values ? currentInstance.values.hs_id : null;
  const knowledgeBaseId = currentInstance && currentInstance.values ? currentInstance.values.hs_group_id : null;
  const settingsDropdownOptions = useSettingsDropdownOptions();
  const isUngatedForLocalizationArticleTitle = useAppSelector(selectIsUngatedForLocalizationArticleTitle);
  const isUngatedForRevisionHistory = useAppSelector(selectIsUngatedForRevisionHistory);
  const groups = useMemo(() => [{
    id: 'file',
    text: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "editor.header.menus.file.label"
    }),
    children: [{
      id: 'new',
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "editor.header.menus.file.createNew"
      }),
      nestedChildren: [{
        id: 'article',
        text: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeArticleEditorUI.header.menus.file.createArticle"
        }),
        onClick: () => {
          if (knowledgeBaseId) {
            setIsCreatingArticle(true);
            createArticle({
              values: {
                hs_name: getDefaultArticleName(isUngatedForLocalizationArticleTitle),
                hs_group_id: knowledgeBaseId
              }
            }).then(response => {
              setIsCreatingArticle(false);
              if (response.createdResourceId) {
                window.location.href = getEditorUrl(response.createdResourceId);
              }
            }).catch(() => {
              setIsCreatingArticle(false);
              FloatingAlertStore.addAlert({
                message: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "knowledgeArticleEditorUI.header.menus.file.createArticleError"
                }),
                type: 'danger'
              });
            });
          }
        },
        loading: isCreatingArticle
      }, {
        id: 'langVariant',
        text: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "editor.header.menus.file.langVariant"
        }),
        onClick: () => dispatch(openModal(MODAL_TYPES.CREATE_MLANG_VARIANT))
      }]
    }, {
      id: 'deletePage',
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "editor.header.menus.file.delete"
      }),
      onClick: () => {
        if (currentArticleId) {
          onDeleteClick(currentArticleId);
        }
      },
      disableLink: !hasPublishPermission
    }, {
      id: 'settings',
      onClick: () => {
        dispatch(updatePatagoniaSettingsModalActiveNavItem('general'));
        dispatch(openModal(MODAL_TYPES.SETTINGS_MODAL));
      },
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeArticleEditorUI.header.menus.file.articleSettings"
      })
    }]
  }, {
    id: 'edit',
    text: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "editor.header.menus.edit.label"
    }),
    children: [{
      id: 'undo',
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "editor.header.menus.edit.undo"
      }),
      onClick: () => dispatch(undoModuleReducerChange()),
      disableLink: !canUndoModules || isReadOnlyMode
    }, {
      id: 'redo',
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "editor.header.menus.edit.redo"
      }),
      onClick: () => dispatch(redoModuleReducerChange()),
      disableLink: !canRedoModules || isReadOnlyMode
    }, {
      id: 'theme_settings',
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeArticleEditorUI.header.menus.edit.themeSettings"
      }),
      onClick: event => {
        if (knowledgeBaseId && themeVariant) {
          const redirectUrl = getThemeSettingsEditorUrl(themeVariant);
          if (event.metaKey || event.ctrlKey) {
            window.open(redirectUrl, '_blank');
          } else {
            window.location.href = redirectUrl;
          }
        }
      }
    }]
  }, {
    id: 'view',
    text: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "editor.header.menus.view.label"
    }),
    children: [{
      id: 'article_details',
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeArticleEditorUI.header.menus.view.articleDetails"
      }),
      href: getKnowledgeArticleDetailsUrl(currentArticleId)
    }, isUngatedForRevisionHistory && {
      id: 'revisions',
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeArticleEditorUI.header.menus.view.revisions"
      }),
      onClick: () => dispatch(routeToPage('revisions'))
    }].filter(option => option)
  }, {
    id: 'settings',
    text: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "editor.header.menus.settings.label"
    }),
    children: settingsDropdownOptions
  }, {
    id: 'help',
    text: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "editor.header.menus.help.label"
    }),
    children: [{
      id: 'knowledgeBase',
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "editor.header.menus.help.knowledgeBase"
      }),
      onClick: () => window.open('https://knowledge.hubspot.com/web-content/topics#knowledge-base')
    }]
  }], [isCreatingArticle, canUndoModules, isReadOnlyMode, canRedoModules, currentArticleId, knowledgeBaseId, onDeleteClick, dispatch, hasPublishPermission, themeVariant, settingsDropdownOptions, isUngatedForLocalizationArticleTitle, isUngatedForRevisionHistory]);
  return groups;
};